'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postStopTrackExitIntent = undefined;

var _createPostMessageAction = require('../../post-message/actions/createPostMessageAction');

var _PostMessageTypes = require('../../constants/PostMessageTypes');

var postStopTrackExitIntent = exports.postStopTrackExitIntent = (0, _createPostMessageAction.createPostMessageAction)(_PostMessageTypes.STOP_TRACK_EXIT_INTENT);